"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M0 0V24H24V0H0ZM2 22V2H8V22H2ZM10 22V12H15V22H10ZM22 22H16.9412V12H22V22ZM10 10.1538V2H22V10.1538H10Z"
}));